import { render, staticRenderFns } from "./Serivce2.vue?vue&type=template&id=c5067514&"
import script from "./Serivce2.vue?vue&type=script&lang=js&"
export * from "./Serivce2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports